import type SvgIcon from "@mui/material/SvgIcon";
import clsx from "clsx";
import { ColorVariant } from "../typography/Typography";
import typo from "../typography/typo.module.scss";
import styles from "./icon.module.scss";

export type IconGlyph = typeof SvgIcon;
export type IconSize = "xs" | "sm" | "md" | "lg" | "xl";

interface Props {
  icon: IconGlyph;
  size?: IconSize;
  color?: ColorVariant;
  className?: string;
}

export default function Icon({ icon: Glyph, size = "md", color, className }: Props) {
  return (
    <span className={clsx(styles.icon, styles[size], color && typo[color], className)} aria-hidden="true">
      <Glyph fontSize="inherit" />
    </span>
  );
}
